module.exports = __webpack_public_path__ + "static/media/logo-famesp.4e2494b2.png";